import * as React from "react";
const SvgBackArrowIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path fillRule="evenodd" clipRule="evenodd" d="M7.59105 4.98592L8.29815 4.27881L9.71237 5.69302L9.00526 6.40013L4.40403 11.0014H22.3335H23.3335V13.0014H22.3335H4.40201L9.00526 17.6046L9.71237 18.3117L8.29815 19.7259L7.59105 19.0188L1.2817 12.7095L0.574593 12.0024L1.2817 11.2953L7.59105 4.98592Z" fill="#CCCCCC" /></svg>;
export default SvgBackArrowIcon;